module.exports = __webpack_public_path__ + "img/VIBE.a2f9cdda.svg";